<div class="slack-integration">
  <div class="slack-logo">
    <img width="22px" height="22px" src="./assets/images/slack-logo.svg" alt="slack logo" />
  </div>
  <div class="slack-text">
    <a [href]="url" class="slack-link">{{ message }}</a>
  </div>
  <button mat-icon-button class="close-slack-ntf">
    <mat-icon>close</mat-icon>
  </button>
</div>
